export default __webpack_public_path__ + "static/media/Bree_light.f56656c4.otf";